import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../../common/Modal';
import Spinner from '../../../../../common/Spinner';

const DisconnectShopify = ({ loadingIsOn, onDisconnect, openedIsOn, openedOn, openedOff }) => (
  <React.Fragment>
    <button
      type="button"
      className="c-btn c-btn--medium c-btn--red"
      onClick={openedOn}
    >
      <span className="c-btn__text">Disconnect shop</span>
    </button>
    <Modal
      className="shopify-modal shopify-disconnect-modal"
      display-if={openedIsOn}
      title="Disconnect Shopify"
      close={openedOff}
      showCloseButton
    >
      <div className="modal-container">
        <div className="modal-container__body">
          <React.Fragment display-if={!loadingIsOn}>
            Are you sure you wish to disconnect your Shopify Integration?
            <p>Disconnecting will desynchronize your matched product inventories
              at fulfillment locations, potentially desynchronize pricing and require reconnection and product matching again if you wanted to connect again.</p>
          </React.Fragment>

          <Spinner display-if={loadingIsOn} />
        </div>
      </div>
      <div className="modal-controls">
        <button
          type="button"
          className="c-btn c-btn--medium c-btn--grey"
          onClick={openedOff}
        >
          <span className="c-btn__text">Cancel</span>
        </button>
        <button
          type="button"
          className="c-btn c-btn--medium c-btn--red"
          onClick={onDisconnect}
        >
          <span className="c-btn__text">Disconnect</span>
        </button>
      </div>
    </Modal>
  </React.Fragment>
);
DisconnectShopify.propTypes = {
  loadingIsOn: PropTypes.bool.isRequired,
  openedIsOn: PropTypes.bool.isRequired,
  openedOff: PropTypes.func.isRequired,
  openedOn: PropTypes.func.isRequired,
  onDisconnect: PropTypes.func.isRequired,
};

export default DisconnectShopify;
